import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import auctionReducer from './slices/auctionSlice';
import walletReducer from './slices/walletSlice';
import uiReducer from './slices/uiSlice';
import whiteLabelReducer from './slices/whiteLabelSlice';
import settingsReducer from './slices/settingsSlice';
import applicationStatusReducer from './slices/applicationStatusSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    auction: auctionReducer,
    wallet: walletReducer,
    ui: uiReducer,
    whiteLabel: whiteLabelReducer,
    settings: settingsReducer,
    applicationStatus: applicationStatusReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auction/updateBidStatus'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export { store };
